import React, { useEffect, useState } from 'react';
import ad_970x90_install from '../../img/ad_970x90_install.png';
import ad_970x90_install2x from '../../img/ad_970x90_install@2x.png';
import ad_970x90_install_en from '../../img/ad_970x90_install_en.png';
import ad_970x90_install_en2x from '../../img/ad_970x90_install_en@2x.png';
import ad_468x60_install from '../../img/ad_468x60_install.png';
import ad_468x60_install2x from '../../img/ad_468x60_install@2x.png';
import ad_468x60_install_en from '../../img/ad_468x60_install_en.png';
import ad_468x60_install_en2x from '../../img/ad_468x60_install_en@2x.png';
import ad_300x250_install from '../../img/ad_300x250_install.png';
import ad_300x250_install2x from '../../img/ad_300x250_install@2x.png';
import ad_300x250_install_en from '../../img/ad_300x250_install_en.png';
import ad_300x250_install_en2x from '../../img/ad_300x250_install_en@2x.png';
import ad_300x250_rapidApi from '../../img/ad_300x250_rapidApi.png';
import ad_300x250_rapidApi_en from '../../img/ad_300x250_rapidApi_en.png';
import ad_300x250_b2b from '../../img/ad_weboffice_kr_300x250.png';
import ad_300x250_b2b2x from '../../img/ad_weboffice_kr_300x250@2x.png';
import ad_300x250_b2b_en from '../../img/ad_weboffice_en_300x250.png';
import ad_300x250_b2b_en2x from '../../img/ad_weboffice_en_300x250@2x.png';
import ad_300x250_b2b_jp from '../../img/ad_weboffice_jp_300x250.png';
import ad_300x250_b2b_jp2x from '../../img/ad_weboffice_jp_300x250@2x.png';
import ad_320x50_install from '../../img/ad_320x50_install.png';
import ad_320x50_install2x from '../../img/ad_320x50_install@2x.png';
import ad_320x50_install_en from '../../img/ad_320x50_install_en.png';
import ad_320x50_install_en2x from '../../img/ad_320x50_install_en@2x.png';
import {
  DIALOG_TYPE,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  LANGUAGE,
  POPUP_TYPE,
  QS_CONSTANT,
  URLS,
  USE_REACT_ROUTER
} from '../../define/global';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { useReplaceEmptyAdSliceSelector } from '../../store/modules/replaceEmptyAd';
import { getPOClientDownloadURL, getLanguage } from '../../utils/util';

import { getQSObject, getValueOfQSObject } from '../../utils/qsUtils';
import ga from '../../utils/gaConnect';
import { useTranslation } from 'react-i18next';
import { selectCurrentProductFromPath } from '../../utils/productSelector';

export const FIXED_AD_ID = {
  // pc
  IN_SHARELINK_DIALOG: 'IN_SHARELINK_DIALOG',
  IN_FILEMENU: 'IN_FILEMENU',
  IN_BODY_POPUP: 'IN_BODY_POPUP',
  IN_OPEN_DOCUMENT_DIALOG: 'IN_OPEN_DOCUMENT_DIALOG',
  IN_DOWNLOAD_DOCUMENT: 'IN_DOWNLOAD_DOCUMENT',

  // mobile
  IN_MOBILE_BOTTOM: 'IN_MOBILE_BOTTOM',
  IN_MOBILE_SHARELINK_DIALOG: 'IN_MOBILE_SHARELINK_DIALOG',
  IN_MOBILE_OPEN_DOCUMENT_DIALOG: 'IN_MOBILE_OPEN_DOCUMENT_DIALOG'
};

const HOUSE_IMAGES = {
  size_320x250_v1: {
    ko: {
      house: ad_300x250_install,
      house2x: ad_300x250_install2x
    },
    en: {
      house: ad_300x250_install_en,
      house2x: ad_300x250_install_en2x
    }
  },
  size_320x250_v2: {
    ko: {
      house: ad_300x250_b2b,
      house2x: ad_300x250_b2b2x
    },
    en: {
      house: ad_300x250_b2b_en,
      house2x: ad_300x250_b2b_en2x
    },
    ja: {
      house: ad_300x250_b2b_jp,
      house2x: ad_300x250_b2b_jp2x
    }
  },
  size_320x250_rapid: {
    ko: {
      house: ad_300x250_rapidApi,
      house2x: ad_300x250_rapidApi
    },
    en: {
      house: ad_300x250_rapidApi_en,
      house2x: ad_300x250_rapidApi_en
    }
  },

  size_320x50: {
    ko: {
      house: ad_320x50_install,
      house2x: ad_320x50_install2x
    },
    en: {
      house: ad_320x50_install_en,
      house2x: ad_320x50_install_en2x
    }
  },
  size_468x60: {
    ko: {
      house: ad_468x60_install,
      house2x: ad_468x60_install2x
    },
    en: {
      house: ad_468x60_install_en,
      house2x: ad_468x60_install_en2x
    }
  },
  size_970x90: {
    ko: {
      house: ad_970x90_install,
      house2x: ad_970x90_install2x
    },
    en: {
      house: ad_970x90_install_en,
      house2x: ad_970x90_install_en2x
    }
  }
};

export const ADs = [
  {
    id: FIXED_AD_ID.IN_SHARELINK_DIALOG,
    parent: DIALOG_TYPE.DIALOG_SHARE_LINK_DOCUMENT,
    width: '468px',
    height: '60px',
    slot: '5145489042',
    img: HOUSE_IMAGES.size_468x60
  },
  {
    id: FIXED_AD_ID.IN_MOBILE_SHARELINK_DIALOG,
    parent: DIALOG_TYPE.DIALOG_SHARE_LINK_DOCUMENT,
    width: '300px',
    height: '250px',
    slot: '2536132417',
    img: HOUSE_IMAGES.size_320x250_v2,
    href: (lang) =>
      URLS.AD.B2B[lang.toUpperCase()] || URLS.AD.B2B[LANGUAGE.EN.toUpperCase()] || null
  },
  {
    id: FIXED_AD_ID.IN_FILEMENU,
    parent: POPUP_TYPE.FILEMENU,
    width: '468px',
    height: '60px',
    slot: '5145489042',
    img: HOUSE_IMAGES.size_468x60
  },
  {
    id: FIXED_AD_ID.IN_BODY_POPUP,
    parent: DIALOG_TYPE.DIALOG_NONE,
    width: '300px',
    height: '250px',
    slot: '2536132417',
    img: HOUSE_IMAGES.size_320x250_rapid,
    href: () =>
      `${URLS.AD.WEB_OFFICE}?utm_source=poweb&utm_medium=inhousead&utm_campaign=rapidAPI&utm_id=rapidAPI`
  },
  {
    id: FIXED_AD_ID.IN_MOBILE_BOTTOM,
    parent: DIALOG_TYPE.DIALOG_NONE,
    width: '320px',
    height: '50px',
    slot: '5548487721',
    img: HOUSE_IMAGES.size_320x50
  },
  {
    id: FIXED_AD_ID.IN_OPEN_DOCUMENT_DIALOG,
    parent: DIALOG_TYPE.DIALOG_OPEN_DOCUMENT,
    width: '970px',
    height: '90px',
    slot: '6283805732',
    img: HOUSE_IMAGES.size_970x90
  },
  {
    id: FIXED_AD_ID.IN_MOBILE_OPEN_DOCUMENT_DIALOG,
    parent: DIALOG_TYPE.DIALOG_OPEN_DOCUMENT,
    width: '320px',
    height: '50px',
    slot: '5548487721',
    img: HOUSE_IMAGES.size_320x50
  },
  {
    id: FIXED_AD_ID.IN_DOWNLOAD_DOCUMENT,
    parent: DIALOG_TYPE.DIALOG_DOWNLOAD_DOCUMENT,
    width: '300px',
    height: '250px',
    slot: '2536132417',
    img: HOUSE_IMAGES.size_320x250_v2,
    edu: HOUSE_IMAGES.size_320x250_v1,
    href: (lang) =>
      URLS.AD.B2B[lang.toUpperCase()] || URLS.AD.B2B[LANGUAGE.EN.toUpperCase()] || null
  }
];
const client = 'ca-pub-1096422525292795';

const sendGAData = (id) => {
  switch (id) {
    case FIXED_AD_ID.IN_MOBILE_SHARELINK_DIALOG:
      ga.event({
        category: 'inhouseAD',
        action: 'B2CWeb',
        label: '인하우스_링크공유'
      });
      break;
    case FIXED_AD_ID.IN_SHARELINK_DIALOG:
      ga.event({
        category: 'Polaris Office 설치',
        action: '설치 바로가기 연결',
        label: '인하우스_링크공유'
      });
      break;
    case FIXED_AD_ID.IN_BODY_POPUP:
      ga.event({
        category: 'inhouseAD',
        action: 'B2CWeb',
        label: '인하우스_본문팝업'
      });
      break;
    case FIXED_AD_ID.IN_OPEN_DOCUMENT_DIALOG:
      ga.event({
        category: 'Polaris Office 설치',
        action: '설치 바로가기 연결',
        label: '인하우스_시작화면'
      });
      break;
    case FIXED_AD_ID.IN_DOWNLOAD_DOCUMENT:
      ga.event({
        category: 'inhouseAD',
        action: 'B2CWeb',
        label: '인하우스_다운로드'
      });
      break;
    default:
      break;
  }
};

export default function FixedAD({ id }) {
  const { i18n } = useTranslation();
  const ad = ADs.find((ele) => ele.id === id);
  const { width, height, slot } = ad;
  const appData = useAppDataSliceSelector();
  const replaceEmptyAd = useReplaceEmptyAdSliceSelector();
  let targetHref = getPOClientDownloadURL({ appData, lang: i18n.language });

  const [house, setHouse] = useState(false);

  // for debug
  /* eslint-disable no-unused-vars */
  const debugPostMsg = () => {
    window.top.postMessage(
      '{"msg_type":"resize-me","key_value":[{"key":"r_nh","value":"0"},{"key":"qid","value":"none"}],"googMsgType":"sth"}',
      '*'
    );
  };
  // useEffect(() => {
  //   // when call debugPostMsg function, logic for replacing house AD starts.
  //   if (id === FIXED_AD_ID.IN_BODY_POPUP) {
  //     debugPostMsg();
  //   }
  // }, []);
  /* eslint-disable no-unused-vars */

  const query = getQSObject();
  const productType = USE_REACT_ROUTER
    ? selectCurrentProductFromPath(location.pathname)
    : getValueOfQSObject(query, QS_CONSTANT.PRODUCT_TYPE.KEY);

  useEffect(() => {
    if (
      (productType === QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_GOOGLE_DRIVE ||
        productType === QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_DROPBOX) &&
      id === FIXED_AD_ID.IN_BODY_POPUP
    ) {
      setHouse(true);
      return;
    }
    if (appData.viewAD === true) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, [appData.viewAD]);

  useEffect(() => {
    if (replaceEmptyAd.id.includes(id)) {
      setHouse(true);
    }
  }, [replaceEmptyAd.id, id]);

  const lang = getLanguage(i18n.language);

  const getHouseImg = ({ productType, lang }) => {
    if (productType === QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_WHALE_SPACE && ad.edu) {
      const house = ad.edu[lang] || ad.img[LANGUAGE.EN];
      if (house) return house;
    }
    return ad.img[lang] || ad.img[LANGUAGE.EN] || { house: null, house2x: null };
  };

  const { house: imgHouse, house2x: imgHouse2x } = getHouseImg({ productType, lang });
  if (productType !== QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_WHALE_SPACE) {
    if (ad.href) {
      targetHref = ad.href(lang) || targetHref;
    }
  }

  return (
    <>
      {appData.viewAD === true && house === false ? (
        <div className="adsenseAdWrapper" width={width} height={height} adwrapperid={id}>
          <ins
            // data-adtest={id === FIXED_AD_ID.IN_MOBILE_BOTTOM ? 'on' : 'off'} // TODO : for test
            className="adsbygoogle"
            style={{ display: 'inline-block', width: width, height: height }}
            data-ad-client={client}
            data-ad-slot={slot}></ins>
        </div>
      ) : (
        <a
          target="_blank"
          href={targetHref}
          rel="noreferrer"
          onClick={() => {
            sendGAData(id);
          }}>
          <img
            width={ad.width}
            height={ad.height}
            src={imgHouse}
            srcSet={imgHouse2x}
            alt="house AD"></img>
        </a>
      )}
    </>
  );
}
